const $ = window.jQuery || window.$;

const refs = {
  bodyEl: $("body"),
  menuButton: $(".menu-button"),
  menuBackdrop: $("#menu"),
  menuNavLinks: $("#menu .nav-list a"),
  appButtons: $(".app-button-js"),
  appBackdrop: $("#appointment"),
  appHideButton: $(".appointment-button"),
  swiperToInit: $(".swiper.init"),
  swiperPagination: $(".swiper-pagination"),
  swiperNavigation: $(".pagination__item"),
  filterButton: $('.filter-button'),
  filterBackdrop: $("#filter"),
  feedbackBackdrop: $('#feedback'),
  feedbackButtons: $('.feedback-js'),
  appointmentButtons: $('.appointment-js'),
  appointmentBackdrop: $('#appointment'),
  appointmentCloseButton: $('#appointment .modal-button'),
  feedbackCloseButton: $('#feedback .modal-button'),
  thankYouCloseButton: $('#thank-you .modal-button'),
  thankYouBackdrop: $('#thank-you'),
	popup_appointment: document.querySelector('#appointment-form--popup'),
	popup_feedback: document.querySelector('#feedback-form--popup'),
};

export default refs;
